import type { IFieldProps } from '../elements/Field';
import type { FormContextProps } from '../elements/formContext';
import { translateKey } from '../../translate';
import { Feedback, InputTextArea, InputTriState } from '../elements/common';
import { Field } from '../elements/Field';

interface ITriStateWithTextInputProps {
    errorText?: string;
    errorTriState?: string;
    onChangeText: (value: string | null) => Promise<void>;
    onChangeTriState: (value: boolean | null) => Promise<void>;
    onDoValidateText?: () => Promise<void>;
    onDoValidateTriState?: () => Promise<void>;
    placeholder?: string;
    triStateName: string;
    valueText: string | null;
    valueTriState: boolean | null;
}

interface IInputTriStateMessageFieldKey {
    fieldKeyText: string;
    fieldKeyTriState: string;
}

type TriStateWithTextProps =
    | ITriStateWithTextInputProps
    | (Partial<ITriStateWithTextInputProps> & IInputTriStateMessageFieldKey);

export function TriStateWithTextInput(props: TriStateWithTextProps) {
    return (
        <div className="layout">
            <InputTriState
                className="mr-2"
                error={props.errorTriState}
                fieldKey={(props as IInputTriStateMessageFieldKey).fieldKeyTriState}
                name={props.triStateName}
                onChange={props.onChangeTriState}
                onDoValidate={props.onDoValidateTriState}
                value={props.valueTriState}
            />
            <InputTextArea
                fieldKey={(props as IInputTriStateMessageFieldKey).fieldKeyText}
                onChange={props.onChangeText}
                onDoValidate={props.onDoValidateText}
                placeholder={props.placeholder}
                rows={1}
                value={props.valueText}
            />
            <Feedback error={props.errorText} />
        </div>
    );
}

export function TriStateWithTextShow(props: { text: string | null; value: boolean | null }) {
    const yesOrNo = props.value ? translateKey('common.yes') : translateKey('common.no');
    if (props.value !== null && props.text !== null) {
        return <>{`${yesOrNo}, ${props.text}`}</>;
    } else if (props.value !== null && props.text === null) {
        return <>{`${yesOrNo}`}</>;
    } else if (props.value === null && props.text !== null) {
        return <>{`${props.text}`}</>;
    } else {
        return null;
    }
}

export function TriStateWithTextField(props: TriStateWithTextProps & FormContextProps<IFieldProps>) {
    return (
        <Field {...props}>
            <TriStateWithTextInput {...props} />
        </Field>
    );
}
